import { createReducer, on } from '@ngrx/store';

import { UserState } from './user.state.interface';
import { setUser, logoutUser, clearUser } from './user.actions';

const initialState: UserState = {
  user: null,
};

export const userReducer = createReducer(
  initialState,
  on(setUser, (state, { user }) => ({ ...state, user })),
  on(logoutUser, (state) => ({ ...state, user: null })),
  on(clearUser, (state) => ({ ...state, user: null })),
);